const initialState = {
  fetching: false,
  saving: false,
  labels: [],
};

const fetch = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_LABELS':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_LABELS_SUCCESS':
      return {
        ...state,
        fetching: false,
        labels: action.labels,
      };

    case 'FETCH_LABELS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'CREATE_LABEL':
      return {
        ...state,
        saving: true,
      };

    case 'UPDATE_LABEL':
      return {
        ...state,
        saving: true,
      };

    case 'CREATE_LABEL_SUCCESS':
      return {
        ...state,
        saving: false,
        labels: [...state.labels, action.label],
      };

    case 'UPDATE_LABEL_SUCCESS':
      return {
        ...state,
        saving: false,
        labels: state.labels.map((l) => (l.id === action.label.id ? action.label : l)),
      };

    case 'DELETE_LABEL':
      return {
        ...state,
        saving: true,
      };

    case 'DELETE_LABEL_SUCCESS':
      return {
        ...state,
        saving: false,
        labels: state.labels.filter((l) => l.id !== action.id),
      };

    case 'CREATE_LABEL_FAILURE':
    case 'DELETE_LABEL_FAILURE':
    case 'UPDATE_LABEL_FAILURE':
      return {
        ...state,
        saving: false,
      };

    default:
      return state;
  }
};

export default fetch;

export const areFetching = (state) => state.fetching;

export const areSaving = (state) => state.saving;

export const getLabels = (state) => state.labels;

export const getLabel = (state, id) => state.labels.find((label) => label.id === id);
